if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.prevButton = this.querySelector('.product-media-modal__nav--prev');
      this.nextButton = this.querySelector('.product-media-modal__nav--next');

      if (this.prevButton) {
        this.prevButton.addEventListener('click', (e) => {
          e.stopPropagation();
          this.navigate(-1);
        });
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', (e) => {
          e.stopPropagation();
          this.navigate(1);
        });
      }

      this.addEventListener('keyup', (event) => {
        if (event.code === 'ArrowLeft') this.navigate(-1);
        if (event.code === 'ArrowRight') this.navigate(1);
      });

      this.setupSwipe();
    }

    setupSwipe() {
      const content = this.querySelector('.product-media-modal__content');
      if (!content) return;

      let startX = 0;
      let startY = 0;
      let tracking = false;

      content.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      }, { passive: true });

      content.addEventListener('touchend', (e) => {
        if (!tracking) return;
        tracking = false;
        const diffX = e.changedTouches[0].clientX - startX;
        const diffY = e.changedTouches[0].clientY - startY;
        if (Math.abs(diffX) > 50 && Math.abs(diffX) > Math.abs(diffY)) {
          this.navigate(diffX > 0 ? -1 : 1);
        }
      }, { passive: true });
    }

    getMediaItems() {
      return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    navigate(direction) {
      const items = this.getMediaItems();
      const activeIndex = items.findIndex((el) => el.classList.contains('active'));
      if (activeIndex === -1) return;

      let newIndex = activeIndex + direction;
      if (newIndex < 0) newIndex = items.length - 1;
      if (newIndex >= items.length) newIndex = 0;

      items.forEach((el) => el.classList.remove('active'));
      items[newIndex].classList.add('active');
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
